import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Col, Row, Button, FormGroup, Label, Input, Spinner, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import axios from "axios";
import moment from "moment-timezone";
import _ from "lodash";
import Switch from "react-switch";
import classes from './CampaignForm.module.scss'

import Table from "./../../../general/Table/Table";
import BoundingBoxMap from "./../../../page/clientCampaign/BoundingBoxMap/BoundingBoxMap";
import CampaignTruckModal from "../CampaignTruckModal/CampaignTruckModal";
import Form from "./../../../general/Form/Form";
import AddTruckModal from "../../../general/AddTruckModal/AddTruckModal";
import Select from 'react-select';
import Loading from "../../../wrapper/Loading/Loading";
import { boxiPrimary } from "../../../../assets/style/colors";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class CampaignForm extends Component {
  state = {
    campaignId: null,
    campaignName: "",
    client: "",
    selectedClient: null,
    campaignStartDate: "",
    campaignEndDate: "",
    campaignViewPriority: null,
    campaignTrucks: [],
    filteredCampaignTrucks: [],
    campaignTrucksToAdd: [],
    campaignTrucksToUpdate: [],
    campaignTrucksToDelete: [],
    placeholderTrucks: [],
    placeholderTrucksToAdd: [],
    placeholderTrucksToUpdate: [],
    placeholderTrucksToDelete: [],
    boundingBoxes: [],
    boundingBoxesToAdd: [],
    boundingBoxesToUpdate: [],
    boundingBoxesToDelete: [],
    clientList: [],
    fullTruckData: [],
    availableTrucksData: [],
    availablePlaceholdersData: [],
    selectedTruckId: null,
    selectedTruckCampaignId: null,
    campaignTruckModalData: null,
    campaignTruckModalShow: false,
    campaignTruckModalEdit: false,
    campaignTruckModalDelete: false,
    csvDownloadEnabled: false,

    isCampaignLoading: false,
    toastHeader: "",
    toastBody: "",
    isToastOpen: false
  };

  campaignTrucksHeaders = [
    "id",
    "Vendor",
    "Truck Name",
    "Macro Truck Name",
    "Display Name",
    // "Artwork Code",
    "License Plate",
    "Tracking Start",
    // "Tracking End",
    "Avg. Mileage",
    "Days Driven Per Week",
    // "Tracking"
  ];
  campaignTrucksButtons = this.props.edit
    ? [
        {
          display: "Edit",
          onClickHandler: (index, id) => {
            let truckCampaign = this.state.campaignTrucks.find((obj) => obj[0] === id);
            this.setState({
              campaignTruckModalShow: true,
              campaignTruckModalEdit: true,
              selectedTruckCampaignId: id,
              campaignTruckModalData: {
                truckId: truckCampaign[1],
                vendorName: truckCampaign[2], 
                truckName: truckCampaign[3], 
                macroId: truckCampaign[4], 
                macroName: truckCampaign[5], 
                displayName: truckCampaign[6], 
                // artworkCode: truckCampaign[7], 
                licensePlate: truckCampaign[7], 
                startDate: truckCampaign[8], 
                // endDate: truckCampaign[10], 
                avgMileage: truckCampaign[9], 
                daysDrivenPerWeek: truckCampaign[10],
                gps_provider: truckCampaign[11]
              }
            });
          }
        },
        {
          display: "Delete",
          onClickHandler: (index, id) => {
            this.setState({
              campaignTruckModalDelete: true,
              selectedTruckCampaignId: id
            });
          }
        }
      ]
    : [];

  placeholderTrucksHeaders = ["id", "Truck Name", "Daily Stops", "Minimum Daily Mileage", "Maximum Daily Mileage"];
  placeholderTrucksButtons = [
    {
      display: "Remove",
      onClickHandler: (index, id) => {
        let placeholders = _.cloneDeep(this.state.placeholderTrucks);
        // show changes in ui
        let indexToRemove = placeholders.findIndex((obj) => obj[0] === id);
        placeholders.splice(indexToRemove, 1);
        // add placeholder to list of placeholders to be deleted
        let placeholdersToDelete = _.cloneDeep(this.state.placeholderTrucksToDelete);
        placeholdersToDelete.push(id);
        // update state
        this.setState({
          placeholderTrucks: placeholders,
          placeholderTrucksToDelete: placeholdersToDelete
        });
      }
    }
  ];

  availableTrucksHeaders = ["id", "Vendor", "Truck Name", "License Plate"];
  availableTrucksButtons = [
    {
      display: "Add",
      onClickHandler: (index, id) => {
        this.setState({
          campaignTruckModalShow: true,
          campaignTruckModalEdit: false,
          selectedTruckId: id
        });
      }
    }
  ];

  availablePlaceholdersHeaders = ["id", "Name"];
  availablePlaceholdersButtons = [
    {
      display: "Add",
      onClickHandler: (index, id) => {
        let placeholders = _.cloneDeep(this.state.placeholderTrucks);
        let availablePlaceholders = _.cloneDeep(this.state.availablePlaceholdersData);
        let placeholdersToAdd = _.cloneDeep(this.state.placeholderTrucksToAdd);
        let placeholder = this.state.fullPlaceholderData.find((placeholder) => placeholder.placeholder_id === id);
        // show changes in ui
        placeholders.push([null, placeholder.name]);
        // remove placeholder from available placeholders list
        let indexToRemove = availablePlaceholders.findIndex((obj) => obj[0] === id);
        availablePlaceholders.splice(indexToRemove, 1);
        // format object to push to db
        placeholdersToAdd.push({
          id: placeholder.placeholder_id,
          name: placeholder.name,
          start_point: placeholder.start_point,
          num_stops: placeholder.num_stops,
          min_mileage: placeholder.min_mileage,
          max_mileage: placeholder.max_mileage,
          min_impressions: placeholder.min_impressions,
          max_impressions: placeholder.max_impressions,
          use_weighting: placeholder.use_weighting
        });
        this.setState({
          placeholderTrucks: placeholders,
          placeholderTrucksToAdd: placeholdersToAdd,
          availablePlaceholdersData: availablePlaceholders
        });
      }
    }
  ];

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    this.setState({
      isCampaignLoading: true
    })
    // format campaign information data
    let campaignData = {
      name: this.state.campaignName,
      user_id: this.state.client ? this.state.client : null,
      start_date: moment(this.state.campaignStartDate).utc().startOf('day').format(),
      end_date: moment(this.state.campaignEndDate).utc().endOf('day').format(),
      view_priority: this.state.campaignViewPriority,
      csv_report_enabled: this.state.csvDownloadEnabled,
    };
    // make calls depending on if form is edit or create
    if (this.props.edit) {
      console.log("UPDATE");
      try {
        // updated campaign information
        let res = await axios.put(`${process.env.REACT_APP_API_HOST}/campaign/${this.state.campaignId}`, campaignData, config);
        if (res.status === 200 && res.data.updated_campaign && res.data.updated_campaign.length > 0) {
          // CAMPAIGN TRUCKS
          let saveCampaignTrucksSuccess = await this.saveCampaignTruckChanges();
          // PLACEHOLDER TRUCKS
          let savePlaceholderTrucksSuccess = await this.savePlaceholderTruckChanges();
          // BOUNDING BOXES
          let saveBoundingBoxesSuccess = await this.saveBoundingBoxChanges();
          // bounding boxes were successful, then update was success
          if (saveBoundingBoxesSuccess && saveCampaignTrucksSuccess && savePlaceholderTrucksSuccess) {
            await this.loadCampaign(this.props.match.params.id);
            this.setState({
              toastHeader: 'Success',
              toastBody: 'Campaign is updated!',
              isToastOpen: true
            })
            setTimeout(() => {
              this.setState({
                isToastOpen: false
              })
            }, 5000);
          }
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      console.log("CREATE");
      try {
        let res = await axios.post(`${process.env.REACT_APP_API_HOST}/campaign`, campaignData, config);
        if (res.data.new_campaign && res.data.new_campaign.length > 0) {
          let campaignId = res.data.new_campaign[0].campaign_id;
          this.setState({
            campaignId: campaignId
          })
          // insert trucks related to inserted campaign
          let campaignTruckAddSuccess = true;
          for (let truck of this.state.campaignTrucksToAdd) {
            // if start/end date are null, set them to campaign start/end dates
            truck.tracking_start = truck.tracking_start
              ? truck.tracking_start
              : moment(this.state.campaignStartDate).utc().startOf('day').format();
            truck.tracking_end = truck.tracking_end
              ? truck.tracking_end
              : moment(this.state.campaignEndDate).utc().endOf('day').format();
            // send request
            let res = await axios.put(
              `${process.env.REACT_APP_API_HOST}/campaign/${campaignId}/truck/${truck.id}`,
              truck,
              config
            );
            // check response to see if query was successful
            if (!(res.status === 200 && res.data.new_truck_campaign && res.data.new_truck_campaign[0].truck_campaign_id)) {
              campaignTruckAddSuccess = false;
            }
          }
          // save any placeholder trucks
          let savePlaceholderTrucksSuccess = await this.savePlaceholderTruckChanges(campaignId);
          // add any new bounding boxes to db
          let boundingBoxAddSuccess = true;
          for (let box of this.state.boundingBoxesToAdd) {
            let res = await axios.put(
              `${process.env.REACT_APP_API_HOST}/campaign/${campaignId}/bounding_box`,
              {
                points: box
              },
              config
            );
            // check response to see if query was successful
            if (!(res.status === 200 && res.data.new_bounding_box && res.data.new_bounding_box[0].bounding_box_id)) {
              boundingBoxAddSuccess = false;
            }
          }
          if (campaignTruckAddSuccess && boundingBoxAddSuccess && savePlaceholderTrucksSuccess) {
            this.setState({
              isCampaignLoading: false,
              toastHeader: 'Success',
              toastBody: 'Campaign Was Created!',
              isToastOpen: true
            })
            setTimeout(() => {
              this.setState({
                isToastOpen: false
              })
              this.props.history.push(`/dashboard/admin/advertise/campaign/edit/${campaignId}`);
            }, 5000);
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
    window.setTimeout(this.loadAvailableTruckInfo, 100);
    window.setTimeout(this.loadAvailablePlaceholderInfo, 200);
    this.setState({
      campaignTrucksToAdd: [],
      campaignTrucksToUpdate: [],
      campaignTrucksToDelete: [],
      placeholderTrucks: [],
      placeholderTrucksToAdd: [],
      placeholderTrucksToUpdate: [],
      placeholderTrucksToDelete: [],
      boundingBoxes: [],
      boundingBoxesToAdd: [],
      boundingBoxesToUpdate: [],
      boundingBoxesToDelete: [],
    })
  };

  deleteCampaign = async (e) => {
    e.preventDefault();
    if (window.confirm(`Are you sure you want to delete this campaign?\nThis action is irreversible.`)) {
      // delete bounding boxes
      let success = true;
      for (let boundingBox of this.state.boundingBoxes) {
        try {
          let res = await axios.delete(
            `${process.env.REACT_APP_API_HOST}/campaign/bounding_box/${boundingBox.bounding_box_id}`,
            { withCredentials: true }
          );
          if (!(res.status === 200 && res.data.deleted_bounding_box && res.data.deleted_bounding_box[0].bounding_box_id)) {
            success = false;
            break;
          }
        } catch (err) {
          console.log(err);
          success = false;
          break;
        }
      }
      // delete placeholder trucks
      for (let placeholder of this.state.placeholderTrucks) {
        try {
          let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/placeholder/campaign/${placeholder[0]}`, {
            withCredentials: true
          });
          if (!(res.status === 200 && res.data.deleted_campaign_placeholder[0].placeholder_id)) {
            success = false;
            break;
          }
        } catch (err) {
          console.log(err);
          success = false;
          break;
        }
      }
      // delete campaign trucks
      for (let truck of this.state.campaignTrucks) {
        try {
          let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/campaign/truck_campaign/${truck[0]}`, {
            withCredentials: true
          });
          if (!(res.status === 200 && res.data.deleted_truck_campaign[0].truck_campaign_id)) {
            success = false;
            break;
          }
        } catch (err) {
          console.log(err);
          success = false;
          break;
        }
      }
      // delete campaign
      try {
        let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/campaign/${this.state.campaignId}`, {
          withCredentials: true
        });
        if (!(res.status === 200 && res.data.deleted_campaign[0].campaign_id)) {
          success = false;
        }
      } catch (err) {
        console.log(err);
        success = false;
      }
      if (success) {
        this.setState({
          isCampaignLoading: false,
          toastHeader: 'Success',
          toastBody: 'Campaign Was Deleted!',
          isToastOpen: true
        })
        setTimeout(() => {
          this.setState({
            isToastOpen: false
          })
          this.props.history.push(`/dashboard/admin/advertise`);
        }, 5000);
      } else {
        this.setState({
          isCampaignLoading: false,
          toastHeader: 'Failure',
          toastBody: 'Problem deleting campaign!',
          isToastOpen: true
        })
        setTimeout(() => {
          this.setState({
            isToastOpen: false
          })
        }, 5000);
      }
    }
  };

  toggleToast = () => {
    this.setState({
      isToastOpen: false
    })
    if (this.state.toastHeader === 'Failure') {
      window.location.reload();
    } else {
      this.props.history.push(`/dashboard/admin/advertise`);
    }
  }

  componentDidMount = () => {
    // load list of client users
    window.setTimeout(this.loadClientUsers, 50);
    window.setTimeout(this.loadAvailableTruckInfo, 100);
    window.setTimeout(this.loadAvailablePlaceholderInfo, 200);
    // if component is edit form, load campaign information into input fields
    if (this.props.edit) {
      this.loadCampaign(this.props.match.params.id);
    }
  };

  loadClientUsers = async () => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/user/client`, { withCredentials: true });
      if (res.status === 200) {
        let clients = res.data.clients
          .map((client) => ({ name: client.name ? client.name : client.email, id: client.user_id }))
          .sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          })
          .map((client) => ({
            value: client.id,
            label: client.name
          }));
          // (
          //   <option key={client.id} value={client.id}>
          //     {client.name}
          //   </option>
          // )
        this.setState({
          clientList: clients
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  loadAvailableTruckInfo = async () => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/truck/all/unassigned_campaign_trucks`, { withCredentials: true });
      console.log('res', res)
      if (res.status === 200 && res.data.trucks) {
        let trucks = res.data.trucks.map((truck) => [truck.truck_id, truck.vendor_name, truck.name, truck.license_plate, truck.artwork_code]);
        console.log('truck', trucks)
        this.setState({
          fullTruckData: res.data.trucks,
          availableTrucksData: trucks
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  loadAvailablePlaceholderInfo = async () => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/unassigned_placeholder`, { withCredentials: true });
      if (res.status === 200 && res.data.placeholders && res.data.placeholders[0].placeholder_id) {
        let placeholders = res.data.placeholders.map((placeholder) => [placeholder.placeholder_id, placeholder.name, placeholder.min_mileage, placeholder.max_mileage, placeholder.min_impressions, placeholder.max_impressions, placeholder.num_stops]);
        this.setState({
          availablePlaceholdersData: placeholders,
          fullPlaceholderData: res.data.placeholders
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  loadCampaign = async (id) => {
    this.setState({
      isCampaignLoading: true
    })
    // get basic campaign information
    await this.getCampaignInfo(id);
    setTimeout(async () => {
      let vehicles = await this.getTruckInfo(id);
      if (vehicles.trucks && vehicles.placeholders) {
        let campaignTrucks = vehicles.trucks
          .filter((truck) => truck.campaign_id)
          .map((truck) => {
            return [
              truck.truck_campaign_id,
              truck.truck_id,
              truck.vendor_name,
              truck.truck_name,
              truck.macro_id,
              truck.macro_name,
              truck.campaign_display_name,
              // truck.artwork_code,
              truck.license_plate,
              truck.tracking_start ? moment(truck.tracking_start).utc().format("M/D/YYYY") : "Campaign Start",
              // truck.tracking_end ? moment(truck.tracking_end).utc().format("M/D/YYYY") : "Campaign End",
              truck.avg_mileage,
              truck.days_driven_per_week,
              truck.gps_provider
              // moment().isBetween(moment(truck.tracking_start), moment(truck.tracking_end))
            ];
          });
        let placeholderTrucks = vehicles.placeholders
          .filter((placeholder) => placeholder.placeholder_id)
          .map((placeholder) => [
            placeholder.placeholder_id,
            placeholder.name,
            placeholder.num_stops,
            placeholder.min_mileage,
            placeholder.max_mileage,
            placeholder.min_impressions,
            placeholder.max_impressions,
          ]);

        let filteredTrucks = JSON.parse(JSON.stringify(campaignTrucks))
        console.log("🚀 ~ file: CampaignForm.js:534 ~ CampaignForm ~ setTimeout ~ filteredTrucks", filteredTrucks)
        if (filteredTrucks[0].length > 0) {
          filteredTrucks.forEach((truck, index) => {
            truck.splice(1, 1)
            truck.splice(3, 1)
          })
        }

        this.setState({
          campaignTrucks: campaignTrucks,
          filteredCampaignTrucks: filteredTrucks,
          placeholderTrucks: placeholderTrucks,
          isCampaignLoading: false
        });
      }
    }, 100);
    setTimeout(() => {
      this.getBoundingBox(id);
    }, 250);
  };

  getCampaignInfo = async (id) => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}`, { withCredentials: true });
      if (res.status === 200 && res.data.campaign) {
        let campaign = res.data.campaign[0];

        this.setState({
          campaignId: campaign.campaign_id,
          campaignName: campaign.name,
          csvDownloadEnabled: campaign.csv_report_enabled,
          client: campaign.user_id ? campaign.user_id : "",
          selectedClient: {
            value: campaign.user_id,
            label: campaign.name,
          },
          campaignStartDate: moment(campaign.start_date).utc().startOf('day').format("YYYY-MM-DD"),
          campaignEndDate: moment(campaign.end_date).utc().endOf('day').format("YYYY-MM-DD"),
          campaignViewPriority: campaign.view_priority
        });
      }
    } catch (err) {
      console.log(`Problem with getting campaign information: ${err}`);
    }
  };

  getTruckInfo = async (id) => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}/truck`, { withCredentials: true });
      if (res.status === 200) {
        let result = {
          trucks: res.data.campaign.trucks,
          placeholders: res.data.campaign.placeholders
        };
        return result;
      }
    } catch (err) {
      console.log(`Problem with getting campaign truck information: ${err}`);
    }
    return [];
  };

  getBoundingBox = async (id) => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}/bounding_box`, { withCredentials: true });
      if (res.status === 200 && res.data.bounding_box && res.data.bounding_box[0].bounding_box_id) {
        console.log("🚀 ~ res.data:", res.data)
        this.setState({
          boundingBoxes: res.data.bounding_box
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  toggleModal = (data) => {
    this.setState({
      campaignTruckModalShow: !this.state.campaignTruckModalShow,
      campaignTruckModalData: null,
      campaignTruckModalEdit: false
    });
  };

  toggleDeleteModal = (data) => {
    this.setState({
      campaignTruckModalDelete: !this.state.campaignTruckModalDelete
    })
  }

  campaignNameChangeHandler = (e) => {
    this.setState({
      campaignName: e.target.value
    });
  };

  clientSelectHandler = (e) => {
    this.setState({
      client: parseInt(e.value)
    });
  };

  impersonateClientButtonHandler = (e) => {
    this.props.history.push(`/dashboard/admin/advertise/client/impersonate/${this.state.client}/campaign/${this.state.campaignId}/map`);
  }

  campaignStartDateHandler = (e) => {
    this.setState({
      campaignStartDate: moment(new Date(`${e.target.value} UTC`)).utc().format('YYYY-MM-DD')
    });
  };

  campaignEndDateHandler = (e) => {
    this.setState({
      campaignEndDate: moment(new Date(`${e.target.value} UTC`)).utc().format('YYYY-MM-DD')
    });
  };

  campaignViewPriorityHandler = (e) => {
    this.setState({
      campaignViewPriority: e.target.value
    });
  };

  csvToggleChangeHandler = (checked) => {
    this.setState({
      csvDownloadEnabled: checked
    });
  };

  updateBoundingBoxes = (boxesToAdd, boxesToUpdate) => {
    this.setState({
      boundingBoxesToAdd: boxesToAdd,
      boundingBoxesToUpdate: boxesToUpdate
    });
  };

  deleteBoungingBoxes = (boxesToDelete) => {
    this.setState({
      boundingBoxesToDelete: [...this.state.boundingBoxesToDelete, ...boxesToDelete]
    });
  };

  addCampaignTruck = (truckId, macroTruckId, displayName, avgMileage, daysDrivenPerWeek, startDate, license_plate, gps_provider) => {
    this.setState({
      selectedTruckId: truckId
    })
    let availableTrucks = _.cloneDeep(this.state.availableTrucksData);
    let indexToRemove = availableTrucks.findIndex((obj) => obj[0] === truckId);
    let truck = this.state.fullTruckData.find((obj) => obj.truck_id === truckId);
    // remove truck from available trucks list
    availableTrucks.splice(indexToRemove, 1);
    
    
    // add placeholder
    let placeholders = _.cloneDeep(this.state.placeholderTrucks);
    let availablePlaceholders = _.cloneDeep(this.state.availablePlaceholdersData);
    let placeholdersToAdd = _.cloneDeep(this.state.placeholderTrucksToAdd);
    let placeholder = this.state.fullPlaceholderData.find((placeholder) => placeholder.placeholder_id === macroTruckId);
    if (placeholder) {
      // show changes in ui
      placeholders.push([null, placeholder.name, placeholder.num_stops, placeholder.min_mileage, placeholder.max_mileage]);
      // remove placeholder from available placeholders list
      let _indexToRemove = availablePlaceholders.findIndex((obj) => obj[0] === macroTruckId);
      availablePlaceholders.splice(_indexToRemove, 1);
    }

    // contruct truck to add to trucks on campaign list
    truck = [
      [
        null,
        truck ? truck.truck_id : '',
        truck ? truck.vendor_name : '',
        truck ? truck.name : '',
        placeholder ? placeholder.id : '',
        placeholder ? placeholder.name : '',
        displayName,
        // truck && truck.artwork_code ? truck.artwork_code : " ",
        truck ? license_plate : '',
        startDate ? moment(startDate).utc().format('YYYY-MM-DD') : "Campaign Start",
        // endDate ? moment(`${endDate} UTC`).utc().format('YYYY-MM-DD') : "Campaign End",
        avgMileage,
        daysDrivenPerWeek,
        gps_provider
      ]
    ];
    let campaignTruck = {
      id: truckId,
      macro_truck_id: macroTruckId,
      avg_mileage: avgMileage,
      days_driven_per_week: daysDrivenPerWeek,
      tracking_start: moment(startDate).utc().startOf('day').format(),
      campaign_display_name: displayName,
      license_plate: license_plate,
      gps_provider
    };


    // update state and add campaign truck to trucks on campaign list
    const tempCampaignTrucks = this.state.campaignTrucks.concat(truck)
    let filteredTrucks = JSON.parse(JSON.stringify(tempCampaignTrucks))
    filteredTrucks.forEach((truck, index) => {
      truck.splice(1, 1)
      truck.splice(3, 1)
    })

    this.setState({
      campaignTrucks: tempCampaignTrucks,
      filteredCampaignTrucks: filteredTrucks,
      campaignTrucksToAdd: this.state.campaignTrucksToAdd.concat(campaignTruck),
      availableTrucksData: availableTrucks,
      selectedTruckId: null,
      campaignTruckModalShow: false
    });

    // format object to push to db
    if (placeholder && !placeholder.is_macro) {
      placeholdersToAdd.push({
        id: placeholder.placeholder_id,
        name: placeholder.name,
        start_point: placeholder.start_point,
        num_stops: placeholder.num_stops,
        min_mileage: placeholder.min_mileage,
        max_mileage: placeholder.max_mileage,
        min_impressions: placeholder.min_impressions,
        max_impressions: placeholder.max_impressions,
        use_weighting: placeholder.use_weighting
      });
      this.setState({
        placeholderTrucks: placeholders,
        placeholderTrucksToAdd: placeholdersToAdd,
        availablePlaceholdersData: availablePlaceholders
      });
    }
  };

  updateCampaignTruck = (truckId, vendorName, truckName, macroId, macroName, displayName, licensePlate, startDate, avgMileage, daysDrivenPerWeek, gps_provider) => {
    let campaignTrucks = _.cloneDeep(this.state.campaignTrucks);
    let campaignTruck;
    if (this.state.selectedTruckCampaignId) {
      // show changes in UI
      let campaignTruckIndex = campaignTrucks.findIndex((obj) => obj[0] === this.state.selectedTruckCampaignId);
      campaignTrucks[campaignTruckIndex][1] = truckId;
      campaignTrucks[campaignTruckIndex][2] = vendorName;
      campaignTrucks[campaignTruckIndex][3] = truckName;
      campaignTrucks[campaignTruckIndex][4] = macroId;
      campaignTrucks[campaignTruckIndex][5] = macroName;
      campaignTrucks[campaignTruckIndex][6] = displayName;
      // campaignTrucks[campaignTruckIndex][7] = artworkCode;
      campaignTrucks[campaignTruckIndex][7] = licensePlate;
      campaignTrucks[campaignTruckIndex][8] = startDate ? moment(startDate).utc().format('YYYY-MM-DD') : "Campaign Start";
      // campaignTrucks[campaignTruckIndex][10] = endDate ? moment(`${startDate} UTC`).utc().format('YYYY-MM-DD') : "Campaign End";
      campaignTrucks[campaignTruckIndex][9] = avgMileage;
      campaignTrucks[campaignTruckIndex][10] = daysDrivenPerWeek;
      campaignTrucks[campaignTruckIndex][11] = gps_provider;

      // add campaign truck to array to be pushed to the backend database
      campaignTruck = {
        truck_campaign_id: this.state.selectedTruckCampaignId,
        truck_id: truckId,
        macro_truck_id: macroId,
        tracking_start: startDate,
        campaign_display_name: displayName,
        avg_mileage: avgMileage,
        days_driven_per_week: daysDrivenPerWeek,
        gps_provider: gps_provider,
        license_plate: licensePlate
      };

      let filteredTrucks = JSON.parse(JSON.stringify(campaignTrucks))
      filteredTrucks.forEach((truck, index) => {
        truck.splice(1, 1)
        truck.splice(3, 1)
      })

      // update state
      this.setState({
        campaignTrucks: campaignTrucks,
        filteredCampaignTrucks: filteredTrucks,
        campaignTrucksToUpdate: this.state.campaignTrucksToUpdate.concat(campaignTruck),
        campaignTruckModalShow: false,
        campaignTruckModalEdit: false,
        selectedTruckCampaignId: null,
        campaignTruckModalData: null
      });
    }
  };

  deleteCampaignTruck = () => {
    // console.log("DELETE campaign truck with id " + this.state.selectedTruckCampaignId);
    // show changes in UI
    let campaignTrucks = this.state.campaignTrucks.filter((obj) => obj[0] !== this.state.selectedTruckCampaignId);

    let filteredTrucks = JSON.parse(JSON.stringify(campaignTrucks))
      filteredTrucks.forEach((truck, index) => {
        truck.splice(1, 1)
        truck.splice(3, 1)
      })

    this.setState({
      campaignTrucks: campaignTrucks,
      filteredCampaignTrucks: filteredTrucks,
      campaignTrucksToDelete: this.state.campaignTrucksToDelete.concat(this.state.selectedTruckCampaignId),
      campaignTruckModalShow: false,
      campaignTruckModalEdit: false,
      selectedTruckCampaignId: null,
      campaignTruckModalData: null,
      campaignTruckModalDelete: false
    });
  };

  saveCampaignTruckChanges = async () => {
    let success = true;
    // add any new campaign trucks
    for (let truck of this.state.campaignTrucksToAdd) {
      // if start/end date are null, set them to campaign start/end dates
      truck.tracking_start = truck.tracking_start
        ? truck.tracking_start
        : moment(this.state.campaignStartDate).utc().startOf('day').format();
      truck.tracking_end = truck.tracking_end ? truck.tracking_end : moment(this.state.campaignEndDate).utc().endOf('day').format();
      truck.campaign_start = moment(this.state.campaignStartDate).utc().startOf('day').format()
      // send request
      let res = await axios.put(
        `${process.env.REACT_APP_API_HOST}/campaign/${this.state.campaignId}/truck/${truck.id}`,
        truck,
        config
      );
      // check response to see if query was successful
      if (!(res.status === 200 && res.data.new_truck_campaign && res.data.new_truck_campaign[0].truck_campaign_id)) {
        success = false;
      }
    }

    // update existing campaign trucks
    for (let truck of this.state.campaignTrucksToUpdate) {
      // if start/end date are null, set them to campaign start/end dates
      truck.tracking_start = truck.tracking_start
        ? truck.tracking_start
        : moment(this.state.campaignStartDate).utc().startOf('day').format();
      truck.tracking_end = truck.tracking_end ? truck.tracking_end : moment(this.state.campaignEndDate).utc().endOf('day').format();
      // send request
      let res = await axios.put(`${process.env.REACT_APP_API_HOST}/campaign/truck_campaign/${truck.truck_campaign_id}`, truck, config);
      // check response to see if query was successful
      if (!(res.status === 200 && res.data.updated_truck_campaign && res.data.updated_truck_campaign[0].truck_campaign_id)) {
        success = false;
      }
    }

    // delete campaign truck
    for (let truckCampaignId of this.state.campaignTrucksToDelete) {
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/campaign/truck_campaign/${truckCampaignId}`, {
        withCredentials: true
      });
      if (!(res.status === 200 && res.data.deleted_truck_campaign && res.data.deleted_truck_campaign[0].truck_campaign_id)) {
        success = false;
      }
    }
    return success;
  };

  savePlaceholderTruckChanges = async (id) => {
    let success = true;
    // add any new placeholder trucks to db
    for (let placeholder of this.state.placeholderTrucksToAdd) {
      placeholder.campaign_id = id ? id : this.state.campaignId;
      let res = await axios.put(`${process.env.REACT_APP_API_HOST}/placeholder/${placeholder.id}`, placeholder, config);
      // check response to see if query was successful
      if (!(res.status === 200 && res.data.updated_placeholder && res.data.updated_placeholder[0].placeholder_id)) {
        success = false;
      }
    }
    // remove placeholder trucks
    for (let placeholderId of this.state.placeholderTrucksToDelete) {
      try {
        let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/placeholder/campaign/${placeholderId}`, {
          withCredentials: true
        });
        if (!(res.status === 200 && res.data.deleted_campaign_placeholder[0].placeholder_id)) {
          success = false;
          break;
        }
      } catch (err) {
        console.log(err);
      }
    }
    return success;
  };

  saveBoundingBoxChanges = async () => {
    let success = true;
    // add any new bounding boxes to db
    for (let box of this.state.boundingBoxesToAdd) {
      let res = await axios.put(
        `${process.env.REACT_APP_API_HOST}/campaign/${this.state.campaignId}/bounding_box`,
        {
          points: box
        },
        config
      );
      // check response to see if query was successful
      if (!(res.status === 200 && res.data.new_bounding_box && res.data.new_bounding_box[0].bounding_box_id)) {
        success = false;
      }
    }
    // update existing bounding boxes
    for (let box of this.state.boundingBoxesToUpdate) {
      let res = await axios.put(
        `${process.env.REACT_APP_API_HOST}/campaign/bounding_box/${box.polygonId}`,
        {
          points: box.points
        },
        config
      );
      // check response to see if query was successful
      if (!(res.status === 200 && res.data.updated_bounding_box && res.data.updated_bounding_box[0].bounding_box_id)) {
        success = false;
      }
    }
    // delete bounding boxes
    for (let boxId of this.state.boundingBoxesToDelete) {
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/campaign/bounding_box/${boxId}`, {
        withCredentials: true
      });
      // check response to see if query was successful
      if (!(res.status === 200 && res.data.deleted_bounding_box && res.data.deleted_bounding_box[0].bounding_box_id)) {
        success = false;
      }
    }
    return success;
  };

  render() {
    const style = {
      padding: "15px 20px"
    };

    const sectionStyle = {
      boxShadow: "none",
      border: "1px solid rgba(0, 0, 0, 0.1)"
    };

    const buttonStyle = {
      float: "left",
      fontSize: "20px",
      marginLeft: "10px",
      minWidth: "30%"
    };

    return (
      <>
        <Loading loading={this.state.isCampaignLoading} label="Loading..." />
        {this.state.toastHeader === 'Success' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg}>
            {this.state.toastBody}
          </Alert>
        }
        {this.state.toastHeader === 'Failure' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg} color="danger">
            {this.state.toastBody}
          </Alert>
        }
        <div formStyle={style}>
          <div className={classes.title}>
            {this.props.edit ? "Edit Campaign" : "Create New Campaign"}
          </div>
          <div className={classes.formContainer}>
            {/* Top row of campaign form */}
            <Row form>
              <Col md={3}>
                <FormGroup>
                  <Label for="campaignName">Campaign Name</Label>
                  <Input
                    type="text"
                    value={this.state.campaignName}
                    onChange={this.campaignNameChangeHandler}
                    id="campaignName"
                    placeholder="Enter campaign name"
                    style={{ marginBottom: "15px" }}
                  />
                  <Label for="clientSelect">Client</Label>
                  {this.state.clientList.length<2 ? (
                      <Spinner
                        style={{ width: "1.2rem", height: "1.2rem", float: "right" }}
                        type="border"
                        color="dark"
                        class="spinner-border-sm"
                      />
                    ):null}

                  <Select
                    isDisabled={this.state.clientList.length < 2}
                    searchable={true}
                    autoload={false}
                    value={this.state.clientList.filter((v) => v.value === this.state.client)}
                    options={this.state.clientList}
                    onChange={this.clientSelectHandler}
                  />

                  <Button className={classes.linkBtn} disabled={this.state.clientList.length<2} onClick={this.impersonateClientButtonHandler}>
                    Impersonate Client
                  </Button>
                </FormGroup>
              </Col>
              <Col md={3} className="pl-5">
                <FormGroup>
                  <Label for="campaignStartDate">Campaign Start Date</Label>
                  <Input
                    type="date"
                    id="campaignStartDate"
                    onChange={this.campaignStartDateHandler}
                    value={this.state.campaignStartDate}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="csvToggle">Enable CSV Download</Label>
                  <Row style = {{marginLeft: '10px'}}>
                    <Switch
                    id="csvToggle"
                    onColor={boxiPrimary}
                    // offColor="rgb(136, 136, 136)"
                    checked={this.state.csvDownloadEnabled}
                    onChange={this.csvToggleChangeHandler} />
                  </Row>
                </FormGroup>
              </Col>
              <Col md={3} className="pl-5">
                <FormGroup>
                  <Label for="campaignEndDate">Campaign End Date</Label>
                  <Input
                    type="date"
                    id="campaignEndDate"
                    onChange={this.campaignEndDateHandler}
                    value={this.state.campaignEndDate}
                  />
                </FormGroup>
              </Col>
              <Col md={3} className="pl-5">
                <FormGroup>
                  <Label for="campaignViewPriority">Campaign View Priority</Label>
                  <Input
                    type="text"
                    value={this.state.campaignViewPriority ? this.state.campaignViewPriority : ""}
                    onChange={this.campaignViewPriorityHandler}
                    id="campaignViewPriority"
                    placeholder="Enter campaign view priority"
                    style={{ marginBottom: "15px" }}
                  />
                </FormGroup>
                <Row form className="mt-4">
                  <Button className={classes.successBtn} style={buttonStyle} onClick={this.onFormSubmitHandler}>
                    {this.props.edit ? "Save" : "Create"}
                  </Button>
                  {this.props.edit ? (
                    <Button color="danger" style={buttonStyle} onClick={this.deleteCampaign}>
                      Delete
                    </Button>
                  ) : null}
                </Row>
              </Col>
            </Row>
          </div>
        </div>
        {/* Campaign truck form row */}
        <Row form className="mb-4">
          <Col xs={12} className="mt-4">
            <Table
              title="Trucks On Campaign"
              id="campaign-trucks-table"
              headers={this.campaignTrucksHeaders}
              data={this.state.filteredCampaignTrucks}
              buttons={this.campaignTrucksButtons}
              colors={["#11998E", "#38EF7D"]}
              sectionStyle={sectionStyle}
              maxHeight="400px"
              available_trucks={this.state.availableTrucksData}
              available_placeholders={this.state.availablePlaceholdersData}
              addCampaignTruck={this.addCampaignTruck}
              editCampaignTruckData={this.state.campaignTruckModalData}
              updateCampaignTruck={this.updateCampaignTruck}
            />
          </Col>
        </Row>
        <Row form className="mb-4">
          <Col md={12}>
            <BoundingBoxMap
              update={this.updateBoundingBoxes}
              delete={this.deleteBoungingBoxes}
              polygons={this.state.boundingBoxes}
            />
          </Col>
        </Row>
        <AddTruckModal
          isEditing={true}
          isModalOpen={this.state.campaignTruckModalEdit} 
          openModal={this.toggleModal}
          trucks={this.state.availableTrucksData}
          placeholders={this.state.availablePlaceholdersData}
          addCampaignTruck={this.props.addCampaignTruck}
          updateCampaignTruck={this.updateCampaignTruck}
          campaignTruckToEdit={this.state.campaignTruckModalData}
        />

        <Modal className={classes.modalDialog} isOpen={this.state.campaignTruckModalDelete} toggle={this.toggleDeleteModal}>
          <ModalHeader toggle={this.toggleDeleteModal}>Delete Truck From Campaign</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this truck from campaign?
            <br />
            This will remove all information of this truck. This action is permament!
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteCampaignTruck}>
              Delete
            </Button>
            <Button color="secondary" onClick={this.toggleDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default withRouter(CampaignForm);
